import { fetcher, IFetchResponseSingle } from "services/api";
import { apiPaths } from "enum/paths.enum";
import { INotification } from "models/notification/notification.model";

export interface FetchNotificationsResponse {
  notifications: INotification[];
  unreadCount: number;
}

export const fetchNotifications = async (): Promise<
  IFetchResponseSingle<FetchNotificationsResponse>
> => {
  return await fetcher({
    url: apiPaths.notifications,
    method: "GET",
  });
};

export const markNotificationRead = async (
  id: number
): Promise<IFetchResponseSingle<{ success: boolean }>> => {
  return await fetcher({
    url: `${apiPaths.notifications}/${id}/read`,
    method: "POST",
  });
};

export const markAllNotificationsRead = async (): Promise<
  IFetchResponseSingle<{ success: boolean }>
> => {
  return await fetcher({
    url: `${apiPaths.notifications}/read-all`,
    method: "POST",
  });
};

// Records that the current user clicked "View details" for a notification.
export const recordNotificationDetailView = async (
  id: number
): Promise<IFetchResponseSingle<{ success: boolean }>> => {
  return await fetcher({
    url: `${apiPaths.notifications}/${id}/view-detail`,
    method: "POST",
  });
};
